<script lang="ts">
  import type { Snippet } from 'svelte';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';
  interface Props {
    children?: Snippet;
  }

  let { children }: Props = $props();

  let brandReskinEnabled = $derived(flagValue(FEATURE_FLAGS.BRAND_RESKIN));
</script>

<strong class={brandReskinEnabled ? 'brand-reskin' : ''}>
  {@render children?.()}
</strong>

<style lang="scss">
  @import 'src/scss/media';

  strong.brand-reskin {
    // Strong mark should render as semibold for all non-heading text
    font-weight: 600;
  }

  :global(.h1),
  :global(.h2),
  :global(.h3),
  :global(.h4),
  :global(.h5),
  :global(.h6) {
    // Headings should not be able to be overridden by strong mark (bold)
    // They should use the values defined in the HeadingSizeDecorator
    strong.brand-reskin {
      font-weight: unset;
    }
  }
</style>
